import { setCookie } from '@utils/safeTs'
import React, { useCallback, useContext, useState } from 'react'

interface TutorialContextType {
  tutorialItems: Record<string, number>
  updateTutorialItem: (key: string, value: number) => void
  nextTutorialItem: (key: string, value: number) => void
  clearTutorial: (startsWith?: string) => void
}

const TutorialContext = React.createContext<TutorialContextType | undefined>(undefined)

export const TutorialContextProvider = ({ children }: { children: React.ReactNode }) => {

  const [tutorialItems, setTutorialItems] = useState({})
  
  const updateTutorialItem = useCallback((key: string, value: number) => {
    setTutorialItems((prev) => ({
      ...prev,
      [key]: value,
    }))
    // setCookie(key, value.toString())
  }, [])

  // procedo allo step specificato se non l'ho già visualizzato
  const nextTutorialItem = useCallback((key: string, value: number) => {
    setTutorialItems((prev) => {
      if (!prev[key] || prev[key] < value) {
        setCookie(key, value.toString())
        return { ...prev, [key]: value }
      }
      return prev
    })
  }, [])

  const clearTutorial = useCallback((tutorialKey: string) => {
    setTutorialItems((prev) => ({...prev, [tutorialKey]: 0 }))
  }, [])

  return (
    <TutorialContext.Provider
      value={{
        tutorialItems,
        updateTutorialItem,
        nextTutorialItem,
        clearTutorial,
      }}
    >
      {children}
    </TutorialContext.Provider>
  )
}

export const useTutorialContext = () => useContext(TutorialContext)
